import { render, staticRenderFns } from "./AdminStatsMessageLabels.vue?vue&type=template&id=6843c62e&"
import script from "./AdminStatsMessageLabels.vue?vue&type=script&lang=js&"
export * from "./AdminStatsMessageLabels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports